import React, { Component } from 'react';

import ReactGA from 'react-ga';

import moment from 'moment';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import AssignmentDetail from './scenes/Assignments/components/AssignmentDetail';
import * as ParseService from './services/parse';
import PlannerAssignmentList from './scenes/Planner/components/PlannerAssignmentList';
import PlannerCalendar from './scenes/Planner/components/PlannerCalendar';

class PlannerSceneCoordinator extends Component {

  constructor(props) {
    super(props);

    this.state = {
      plannerItems: [],
      selectedDate: new Date(),
      period: 'week',
      selectedItem: null,
    };

    this.handleCalendarNavigate = this.handleCalendarNavigate.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview('/planner');
  }

  componentWillMount() {
    this.fetchItems(this.state.selectedDate, this.state.period);
  }

  handleCalendarNavigate(date, period) {
    this.setState({
      selectedDate: date,
      period: period
    });

    this.fetchItems(date, period);
  }

  fetchItems(date, period) {
    const that = this;

    const start = moment(date).startOf(period).toDate();
    const end = moment(date).endOf(period).toDate();
    ParseService.findAssignmentsPlannedInRange(start, end, {
      success: function(results) {
        that.setState({plannerItems: results});
      },
      error: function(err) {
        console.log("Failed to fetch planned Assignments " + err);
      }
    });

  }

  render() {
    var itemDetails = null;
    if (this.state.selectedItem != null) {
      const actions = [
        <FlatButton 
          label="Done" 
          onClick={() => this.setState({selectedItem: null})}
          primary={true} />
      ];

      itemDetails = (
        <Dialog
          title="Assignment Details"
          actions={actions}
          open={true}
          contentStyle={{width: '400px'}}
          autoScrollBodyContent={true}
          onRequestClose={() => this.setState({selectedItem: null})}>
          
          <div className='dialog-detail-container'>
            <AssignmentDetail item={this.state.selectedItem} />
          </div>

        </Dialog>
      );
    }

    return (
      <div className="scene-box">
        <PlannerCalendar 
          onChange={this.handleCalendarNavigate}
          defaultView='week' />
        <PlannerAssignmentList 
          items={this.state.plannerItems}
          date={this.state.selectedDate}
          period={this.state.period}
          onItemSelected={(item) => this.setState({selectedItem: item})} />
        { itemDetails }
      </div>
    );
  }
}

export default PlannerSceneCoordinator;


// WEBPACK FOOTER //
// ./src/PlannerSceneCoordinator.js